import { isDefined } from "@clipboard-health/util-ts";
import { useGetWorkplace } from "@src/appV2/FacilityProfile/api/useGetWorkplace";

export function useGetDefaultChartingPassword(params: { workplaceId: string | undefined }) {
  const { workplaceId } = params;
  const {
    data: workplaceResponse,
    isLoading,
    isSuccess,
  } = useGetWorkplace({ workplaceId }, { enabled: isDefined(workplaceId) });
  const defaultChartingPassword = workplaceResponse?.data.attributes.defaultChartingPassword;
  return {
    defaultChartingPassword,
    isLoading,
    isSuccess,
  };
}
